module.exports = __webpack_public_path__ + "static/media/Dustin_C.448f39d7.jpg";